<template>
    <div v-b-tooltip.hover class="well-chamber-number" :title="title">
        {{ slidePositionPrefix }} #{{ selectedSlide.slidePosition }}
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { INSTRUMENT_TYPE } from '../../business/const'

export default {
    name: 'WellChamberNumber',
    computed: {
        ...mapState({
            selectedSlide: state => state.timelapse.selectedSlide
        }),
        ...mapGetters({
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        instrumentType() {
            return this.getSelectedInstrument.type
        },
        title() {
            let title = ''
            switch (this.instrumentType) {
                case INSTRUMENT_TYPE.GERI:
                    title = this.$translate('chamber')
                    break
                case INSTRUMENT_TYPE.MIRI:
                    title = this.$translate('compartment')
                    break
            }
            return `${title} + number`
        },
        slidePositionPrefix() {
            switch (this.instrumentType) {
                case INSTRUMENT_TYPE.GERI:
                    return this.$translate('chamber')
                case INSTRUMENT_TYPE.MIRI:
                    return this.$translate('comp')
                default:
                    return null
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.well-chamber-number {
    white-space: nowrap;
    color: $light-3;
    border-radius: $border-radius-sm;
}
</style>
